<app-breadcrumbs [breadcrumbs]="breadcrumbs" [showHome]="false" class="d-block mb-4"></app-breadcrumbs>

<h2>{{ prefix + '-titel' | fromDictionary }}</h2>

<div class="text-max-width">
  @if (setForm$()) {
    <fstr-dynamic-form
      [config]="formFields"
      [appearance]="'fill'"
      (formSubmit)="handleSubmit($event)"
      [showSubmit]="false"
      [showAlerts]="false"
      #form
      [fieldsets]="fieldsets"
      >
      <div slot="form-actions" class="text-center">
        @if (customerUpdateErrors$()?.length) {
          @if (customerUpdateErrors$(); as errors) {
            <app-alert
              class="d-block mb-4"
              [status]="'type--danger'"
              [title]="prefix + '-formulier-server-errors-titel' | fromDictionary"
              [showDefaultError]="true"
              [errors]="errors"
            ></app-alert>
          }
        }
        <button type="submit" class="button button--secondary" [disabled]="customerUpdating$() || form.form.pending">
          <span>{{ prefix + '-knop-tekst' | fromDictionary }}</span>
          @if (customerUpdating$() || form.form.pending) {
            <span class="icon-loader css-icon" title="laden"></span>
          }
        </button>
      </div>
    </fstr-dynamic-form>
  }

  @if (customerUpdateSuccess$()) {
    <app-alert
      class="d-block mt-4"
      [message]="prefix + '-formulier-succes-geslaagd-tekst' | fromDictionary"
      [status]="'type--success'"
      [title]="prefix + '-formulier-succes-geslaagd-titel' | fromDictionary"
    ></app-alert>
  }

  <!-- <app-alert
  class="d-block mt-4"
  *ngIf="getServerError(!!(customerUpdateErrors$ | async)?.length)"
  [message]="prefix + '-formulier-error-tekst' | fromDictionary"
  [status]="'type--danger'"
  [title]="prefix + '-formulier-error-titel' | fromDictionary"
></app-alert> -->
</div>
